import { render, staticRenderFns } from "./DirSelectItem.vue?vue&type=template&id=258ff15d&scoped=true"
import script from "./DirSelectItem.vue?vue&type=script&lang=js"
export * from "./DirSelectItem.vue?vue&type=script&lang=js"
import style0 from "./DirSelectItem.vue?vue&type=style&index=0&id=258ff15d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258ff15d",
  null
  
)

export default component.exports